module.exports = __webpack_public_path__ + "assets/img/driver-btn-853a70a3.png";